import React from 'react';
import { useApi } from '../hooks/useApi';
import { apiService } from '../services/api';

interface PrivacyPolicyData {
  title?: string;
  content?: string;
}

function PrivacyPolicy(): React.JSX.Element {
  const { data, loading, error } = useApi(apiService.getPrivacyPolicy);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '50vh',
        fontFamily: 'var(--font-body)'
      }}>
        Laden...
      </div>
    );
  }

  if (error || !data) {
    // Fallback content
    const fallbackData: PrivacyPolicyData = {
      title: 'Privacy Policy',
      content: `
        <h2>1. Inleiding</h2>
        <p>Hairmedics respecteert uw privacy en zorgt ervoor dat persoonlijke informatie die u ons verschaft vertrouwelijk wordt behandeld. Deze privacy policy is van toepassing op alle diensten van Hairmedics.</p>

        <h2>2. Verzameling van gegevens</h2>
        <p>Wij verzamelen alleen persoonlijke gegevens die u ons vrijwillig verstrekt, zoals:</p>
        <ul>
          <li>Naam en contactgegevens</li>
          <li>Medische informatie relevant voor de behandeling</li>
          <li>Afspraakgegevens</li>
        </ul>

        <h2>3. Doel van gegevensverwerking</h2>
        <p>Uw persoonlijke gegevens worden gebruikt voor:</p>
        <ul>
          <li>Het maken en beheren van afspraken</li>
          <li>Het uitvoeren van behandelingen</li>
          <li>Het verstrekken van medische zorg</li>
          <li>Communicatie over uw behandeling</li>
        </ul>

        <h2>4. Bewaartermijn</h2>
        <p>Wij bewaren uw gegevens niet langer dan noodzakelijk voor de doeleinden waarvoor ze zijn verzameld. Medische gegevens worden bewaard volgens de wettelijke bewaartermijn van 20 jaar.</p>

        <h2>5. Uw rechten</h2>
        <p>U heeft het recht om:</p>
        <ul>
          <li>Uw gegevens in te zien</li>
          <li>Uw gegevens te laten corrigeren</li>
          <li>Uw gegevens te laten verwijderen</li>
          <li>Bezwaar te maken tegen verwerking</li>
        </ul>

        <h2>6. Beveiliging</h2>
        <p>Wij nemen passende technische en organisatorische maatregelen om uw persoonlijke gegevens te beschermen tegen verlies of onrechtmatige verwerking.</p>

        <h2>7. Contact</h2>
        <p>Voor vragen over deze privacy policy kunt u contact met ons opnemen via:</p>
        <p>Telefoon: 072 5338718<br />
        E-mail: info@hairmedics.nl</p>
      `
    };

    return (
      <section className="legal-page">
        <div className="legal-content">
          <h1 className="legal-title">{fallbackData.title}</h1>
          <div 
            className="legal-text"
            dangerouslySetInnerHTML={{ __html: fallbackData.content }}
          />
        </div>
      </section>
    );
  }

  const pageData = data as PrivacyPolicyData;

  return (
    <section className="legal-page">
      <div className="legal-content">
        <h1 className="legal-title">{pageData.title || 'Privacy Policy'}</h1>
        <div 
          className="legal-text"
          dangerouslySetInnerHTML={{ __html: pageData.content || '' }}
        />
      </div>
    </section>
  );
}

export default PrivacyPolicy; 